import {DataBaseHandler} from "./DataBaseHandler";
import {DataHandler} from "./DataHandler";

export class IngredientDataHandler {

    public static ingredientListeners: ((ingredients: Ingredient[]) => void)[] = []
    public static initIngredientSchema(db: IDBDatabase) {
        const ingredientsStore = db.createObjectStore("ingredients", { keyPath: "name" })
        ingredientsStore.createIndex("price", ["price"], { unique: false })
        ingredientsStore.createIndex("mass", ["mass"], { unique: false })
        ingredientsStore.createIndex("massUnit", ["massUnit"], { unique: false })
        ingredientsStore.createIndex("currency", ["currency"], { unique: false })
    }

    public static addIngredient(ingredient: Ingredient) {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).add({storeName: "ingredients", data: ingredient}).then(val => {
            IngredientDataHandler.notifyIngredientListeners(val.currentRecords)
            return (val.requestRecord)
        })
    }

    public static updateIngredient(ingredient: Ingredient, oldNameToDelete?: string) {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).update({storeName: "ingredients", data: ingredient, oldNameToDelete: oldNameToDelete}).then(val => {
            IngredientDataHandler.notifyIngredientListeners(val.currentRecords)
            return val.requestRecord
        })
    }

    public static deleteIngredient(ingredient: Ingredient) {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).delete({storeName: "ingredients", data: ingredient}).then(val => {
            IngredientDataHandler.notifyIngredientListeners(val.currentRecords)
            return val.requestRecord
        })
    }

    public static getIngredients() {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).get({storeName: "ingredients"}).then(val => {
            return val.currentRecords
        })
    }

    static getIngredientByName(name: string) {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).get({storeName: "ingredients", name}).then(val => {
            return val.requestRecord
        })
    }

    public static notifyIngredientListeners (ingredients: Ingredient[]) {
        this.ingredientListeners.forEach(listener => {
            listener(ingredients)
        })
    }

    public static registerIngredientListener (listener: (i: Ingredient[]) => void) {
        IngredientDataHandler.ingredientListeners.push(listener)
    }

}
